/* Cart popup being displayed when the user clicks on the cart icon */
import axios from 'axios';
import { formatMoney } from '@shopify/theme-currency';

/**
 * Export default AjaxCart.
 */
export default () => {
  const selectors = {
    freeShipping: '[js-freeshipping="info"]',
    freeShippingBar: '[js-freeshipping="bar"]',
  };

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    freeShipping: document.querySelectorAll(selectors.freeShipping),
    freeShippingBar: document.querySelectorAll(selectors.freeShippingBar),
  };

  function init() {
    if (theme.ajaxCart.freeShipping === false) {
      return false;
    }

    getCartJSON();
    setBusListeners();
  }

  function setBusListeners() {
    Karmoon.EventBus.listen('AjaxCart:updated', (cartData) => {
      getCartJSON();
    });

    Karmoon.EventBus.listen(
      ['AddToCart:itemRemoved', 'AddToCart:itemAdded', 'Cart:itemAdded', 'Cart:updated'], (cartData) => {
      getCartJSON();
    });
  }

  function getCartJSON(callback, x, y) {
    axios
      .get(`/cart.js?no-cache}`)
      .then((response) => {
        freeShippingCheck(response.data);
      })
      .catch((error) => {
        window.console.error(error);
        return error;
      });
  }

  // Free Shipping
  function freeShippingCheck(cart) {
    const freeShippingTheshold = theme.ajaxCart.freeShippingTheshold * 100;
    const cartTotal = cart.total_price;
    const valueUntilFree = freeShippingTheshold - cartTotal;
    const percentUntilFree = `${(cartTotal / freeShippingTheshold) * 100}%`;
    const formatValueUntilFree = formatMoney(valueUntilFree, theme.moneyFormat);
    const freeShippingText = `Spend ${formatValueUntilFree} more to get free shipping`;

    if (valueUntilFree <= 0) {
      nodeSelectors.freeShipping.forEach((item) => {
        item.innerHTML = 'Free shipping on this order';
      });
      nodeSelectors.freeShippingBar.forEach((item) => {
        item.style.width = percentUntilFree;
      });
    } else {
      nodeSelectors.freeShipping.forEach((item) => {
        item.innerHTML = freeShippingText;
      });
      nodeSelectors.freeShippingBar.forEach((item) => {
        item.style.width = percentUntilFree;
      });
    }
  }

  /**
   * Return immutable object.
   */
  return Object.freeze({
    init,
  });
};
